import axios, { AxiosRequestConfig } from "axios";
import { authClient } from "../lib/auth-client";
import { queryClient } from "./query-client";

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

// On 401 response, sign out and redirect to login
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            await authClient.signOut();
            queryClient.clear();
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export const fetchData = async (url: string, options: AxiosRequestConfig = {}) => {
    try {
        const response = await api.get(url, options);
        return response?.data?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const postData = async (url: string, data: any, options: AxiosRequestConfig = {}) => {
    try {
        const response = await api.post(url, data, options);
        return response?.data?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export default api;
